import { combineReducers } from '@reduxjs/toolkit';

import getCustomers from './get_customers';
import getCustomer from './get_customer';
import getCustomersByIds from './get_customers_by_ids';
import getCustomersByPhoneNumber from './get_customers_by_phone_number';
import getCustomerActivities from './get_customer_activities';
import getIncorrectEmails from './get_incorrect_emails';
import createIncorrectEmail from './create_incorrect_email';
import createIncorrectEmailSms from './create_incorrect_email_sms';
import getCustomerBlockadeHistoryRegistries from './get_customers_blockade_history_registries';
import getCustomerBlockadeRegistries from './get_customers_blockade_registries';
import deleteCustomerBlockadeRegistry from './delete_customer_blockade_registry';
import createCustomerBlockadeRegistry from './create_customer_blockade_registry';

export default combineReducers({
    getCustomers,
    getCustomer,
    getCustomersByIds,
    getCustomersByPhoneNumber,
    getCustomerActivities,
    getIncorrectEmails,
    createIncorrectEmail,
    createIncorrectEmailSms,
    getCustomerBlockadeHistoryRegistries,
    getCustomerBlockadeRegistries,
    deleteCustomerBlockadeRegistry,
    createCustomerBlockadeRegistry,
});
